import moment from 'src/app/utils/moment';

export interface SupplementCategory {
    id: string;
    title: string;
    supplements: any[];
    notes?: string;
}

export interface ISupplementProtocolDetail {
    id: string;
    title: string,
    createdBy?: string;
    creationDate?: string;
    startDate: string,
    startDateHidden?: boolean;
    endDate?: string,
    endDateHidden?: boolean;
    protocols: any[],
    notes?: string[],
    readNotes?: boolean,
    isPremium?: boolean
}

export class  SupplementProtocol {
    id: string = null;
    title: string = null;
    comments: any[] = [];
    startDate: string = null;
    startDateHidden?: boolean = null;
    endDate?: string = null;
    endDateHidden?: boolean = null;
    protocols: any[] = [{categories: []}];
    createdBy: string = null;
    creationDate: string = null;
    lastModifiedBy: string = null;
    lastModifiedDate: string = null;
    notes: string[] = [];
    draftSupplementProtocol: any;
    published?: string;
    organization: string;
    readNotes:boolean;
    isPremium?: boolean

    constructor (init: Partial<SupplementProtocol>){
        Object.assign(this, init);
    }

    isPublished(): boolean {
        return this.hasOwnProperty("published") && this.hasOwnProperty("protocols") && this.protocols[0] && this.protocols[0].hasOwnProperty("categories") && this.protocols[0].categories.length > 0
    }

    hasDraft(): boolean {
        return this.hasOwnProperty("draftSupplementProtocol");
    }

    clone(): SupplementProtocol {
        return Object.assign({}, this);
    }

    cloneActive(): ISupplementProtocolDetail {
        const toReturn =  {
            id: this.id,
            title: this.title,
            startDate: this.startDate,
            startDateHidden: this.startDateHidden,
            createdBy: this.createdBy,
            creationDate: this.creationDate,
            endDate: this.endDate,
            endDateHidden: this.endDateHidden,
            protocols: this.protocols,
            notes: this.notes,
            isPremium: this.isPremium
        }
        return JSON.parse(JSON.stringify(toReturn))
    }

    cloneDraft(): ISupplementProtocolDetail {
        let obj = Object.assign({}, this.draftSupplementProtocol);
        // Fallback for browser bug
        obj.title = obj.title || this.title;
        obj.notes = obj.notes || this.notes;
        obj.createdBy = this.createdBy || null,
        obj.creationDate = this.creationDate || null,
        obj.id = this.id;
        return obj
    }

    isStartDateValid() {
      return !this.startDate || !this.startDateHidden || (moment as any)().isSameOrAfter((moment as any)(this.startDate))
    }
        
    
    isEndDateValid() {
      return !this.endDate || !this.endDateHidden || (moment as any)().isSameOrBefore((moment as any)(this.endDate))
    }

    getStatus() {
        if(this.hasDraft()) {
            return "draft"
        } else if(!this.isEndDateValid()) {
            return "expired"
        } else if((moment as any)(this.startDate).isAfter((moment as any)())) {
            return "scheduled"
        } else {
            return "published"
        }
    }
}